import React from "react";

const AggregatedTable = ({
  aggregatedData,
  currencySymbol,
  showAggregatedView,
  onToggleView,
  isLoading,
}) => {
  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
      {/* Modern Table Header */}
      <div className="bg-gradient-to-r from-gray-900 to-black px-6 py-4 flex items-center justify-between border-b-2 border-white">
        <h3 className="text-white text-lg font-semibold">Order Summary</h3>
        {onToggleView && (
          <button
            onClick={onToggleView}
            className="flex items-center gap-2 px-3 py-1.5 bg-white/10 hover:bg-white/20 border border-white/30 rounded-md transition-all duration-200 text-white text-xs font-medium"
            title="Show Detailed Table"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
              />
            </svg>
            Show Details
          </button>
        )}
      </div>

      {isLoading ? (
        <div className="px-6 py-12 text-center">
          <div className="animate-pulse flex flex-col items-center justify-center">
            <svg className="w-10 h-10 text-gray-300 mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            <p className="text-gray-500 font-medium text-lg">Loading summary data...</p>
          </div>
        </div>
      ) : aggregatedData.length > 0 ? (
        <div className="overflow-x-auto max-h-[600px] overflow-y-auto">
          <table className="w-full">
            <thead className="bg-gradient-to-r from-gray-900 to-black sticky top-0 z-10">
              <tr>
                <th className="px-6 py-5 text-left text-sm font-bold text-white uppercase tracking-wider">
                  Order Type
                </th>
                <th className="px-6 py-5 text-left text-sm font-bold text-white uppercase tracking-wider">
                  Total Orders
                </th>
                <th className="px-6 py-5 text-left text-sm font-bold text-white uppercase tracking-wider">
                  Total Sales
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100">
              {aggregatedData.map((row, index) => (
                <tr
                  key={index}
                  className="h-[70px] hover:bg-gradient-to-r hover:from-gray-50 hover:to-white transition-all duration-200 hover:shadow-sm"
                >
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="font-semibold text-gray-900 text-base">
                      {row.orderType}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="font-semibold text-blue-600 text-base">
                      {row.totalOrders === null || row.totalOrders === undefined
                        ? "-"
                        : row.totalOrders}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="font-semibold text-green-600 text-base">
                      {currencySymbol}
                      {Number(row.totalSales ?? 0).toFixed(2)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="px-6 py-12 text-center">
          <p className="text-gray-500">
            No orders available for the selected date range
          </p>
        </div>
      )}
    </div>
  );
};

export default AggregatedTable;
